import PropTypes from "prop-types"

import Column from "../../../common/components/Column"
import { useAdminPaginatedQuery } from "../hooks/useAdminPaginatedQuery"
import AdminListToolbar from "./AdminListToolbar"
import AdminListingTable from "./AdminListingTable"
import AdminPageHeader from "./AdminPageHeader"

export default function AdminRegistryListPage({
  title,
  subtitle,
  fetchFn,
  extraParams = {},
  filterSpecs = null,
  toolbarFilters = [],
  noun = "results",
  defaultSortColumn = "created",
  defaultSortDirection = "desc",
  searchLabel = "Search",
  columnCount,
  tableHead,
  children,
}) {
  const query = useAdminPaginatedQuery(fetchFn, {
    extraParams,
    filters: filterSpecs,
    defaultSortColumn,
    defaultSortDirection,
  })

  return (
    <Column gap={2}>
      <AdminPageHeader title={title} subtitle={subtitle} />
      <AdminListToolbar
        query={query}
        searchLabel={searchLabel}
        noun={noun}
        filters={toolbarFilters}
      />
      <AdminListingTable
        rows={query.rows}
        isLoading={query.isLoading}
        pageIndex={query.pageIndex}
        setPageIndex={query.setPageIndex}
        pageSize={query.pageSize}
        setPageSize={query.setPageSize}
        totalResultsSize={query.totalResultsSize}
        columnCount={columnCount}
        tableHead={
          typeof tableHead === "function" ? tableHead(query) : tableHead
        }
      >
        {children(query.rows)}
      </AdminListingTable>
    </Column>
  )
}

AdminRegistryListPage.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  fetchFn: PropTypes.func.isRequired,
  extraParams: PropTypes.object,
  filterSpecs: PropTypes.object,
  toolbarFilters: PropTypes.array,
  noun: PropTypes.string,
  defaultSortColumn: PropTypes.string,
  defaultSortDirection: PropTypes.string,
  searchLabel: PropTypes.string,
  columnCount: PropTypes.number.isRequired,
  /** A node, or (query) => node to render sortable headers. */
  tableHead: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  children: PropTypes.func.isRequired,
}
